/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DocumentSubType,
    DocumentSubTypeFromJSON,
    DocumentSubTypeFromJSONTyped,
    DocumentSubTypeToJSON,
    SimilarRequestSearchContextParties,
    SimilarRequestSearchContextPartiesFromJSON,
    SimilarRequestSearchContextPartiesFromJSONTyped,
    SimilarRequestSearchContextPartiesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimilarRequestSearchContext
 */
export interface SimilarRequestSearchContext {
    /**
     * 
     * @type {DocumentSubType}
     * @memberof SimilarRequestSearchContext
     */
    documentSubType?: DocumentSubType;
    /**
     * 
     * @type {Array<string>}
     * @memberof SimilarRequestSearchContext
     */
    legalDomain?: Array<string> | null;
    /**
     * 
     * @type {SimilarRequestSearchContextParties}
     * @memberof SimilarRequestSearchContext
     */
    parties?: SimilarRequestSearchContextParties | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSearchContext
     */
    sourceDocumentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequestSearchContext
     */
    sourceDocumentSectionName?: string | null;
}

export function SimilarRequestSearchContextFromJSON(json: any): SimilarRequestSearchContext {
    return SimilarRequestSearchContextFromJSONTyped(json, false);
}

export function SimilarRequestSearchContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequestSearchContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentSubType': !exists(json, 'documentSubType') ? undefined : DocumentSubTypeFromJSON(json['documentSubType']),
        'legalDomain': !exists(json, 'legalDomain') ? undefined : json['legalDomain'],
        'parties': !exists(json, 'parties') ? undefined : SimilarRequestSearchContextPartiesFromJSON(json['parties']),
        'sourceDocumentName': !exists(json, 'sourceDocumentName') ? undefined : json['sourceDocumentName'],
        'sourceDocumentSectionName': !exists(json, 'sourceDocumentSectionName') ? undefined : json['sourceDocumentSectionName'],
    };
}

export function SimilarRequestSearchContextToJSON(value?: SimilarRequestSearchContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentSubType': DocumentSubTypeToJSON(value.documentSubType),
        'legalDomain': value.legalDomain,
        'parties': SimilarRequestSearchContextPartiesToJSON(value.parties),
        'sourceDocumentName': value.sourceDocumentName,
        'sourceDocumentSectionName': value.sourceDocumentSectionName,
    };
}


